import React, { useMemo } from "react";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Typography,
} from "@mui/material";

import { BarChart } from "@mui/x-charts/BarChart";
import { useGetUserPerQuizQuery } from "../../Apis/progressApi";

export interface UsersPerQuiz {
  quizName: string;
  count: number;
}

export default function UserEngagementPerQuiz() {
  const { data = [], isLoading, isError } = useGetUserPerQuizQuery();

  const chartData = useMemo(() => {
    // optional: sort descending so top quizzes appear first
    return [...data].sort((a, b) => b.count - a.count);
  }, [data]);

  const totalUsers = useMemo(
    () => chartData.reduce((sum, item) => sum + item.count, 0),
    [chartData]
  );

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: 6,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (isError) {
    return (
      <Typography
        color="error"
        sx={{
          textAlign: "center",
          p: 4,
          fontWeight: 600,
        }}
      >
        Failed to load quiz engagement data
      </Typography>
    );
  }

  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: 3,
        overflow: "hidden",
      }}
    >
      <CardHeader
        sx={{ background: "#f8f8f8" }}
        title={
          <Typography variant="h6" sx={{ fontWeight: 700, color: "#512384" }}>
            User Engagement Per Quiz
          </Typography>
        }
      />

      <CardContent>
        <Typography
          variant="h6"
          sx={{ mb: 3, fontWeight: 700, color: "#512384" }}
        >
          Total Users: {totalUsers}
        </Typography>

        <Box sx={{ width: "100%", overflowX: "auto" }}>
          <BarChart
            height={380}
            xAxis={[
              {
                scaleType: "band",
                data: chartData.map((x) => x.quizName),
                tickLabelStyle: {
                  fontSize: 11,
                },
              },
            ]}
            series={[
              {
                data: chartData.map((x) => x.count),
                color:"#512384",
                valueFormatter: (value) => `${value} users`,
              },
            ]}
          />
        </Box>
      </CardContent>
    </Card>
  );
}